import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/unreal-game-update/unreal_game_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Unreal Engine Game Development Company
              </h1>
              <span>
                Photo-
                <span style={{ color: "#f47a14" }}>Realistic Graphics</span>,
                Seamless Interactions
              </span>
              <p style={{ marginTop: "10px" }}>
                Develop top-tier games with advanced real-time rendering,
                physics-based simulations, and optimized performance. Our Unreal
                Engine game development expertise ensures precision in every
                aspect, from intricate environment design to complex AI systems,
                delivering experiences that meet the highest industry standards
                and drive player engagement
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult Your Game Project
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
